// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"Dashboard_dashboardWrapper__eSGYu","dashboardRight":"Dashboard_dashboardRight__CAJFh"};